    <template>
    <div>
        <router-link
                     :to="'pos/'+row.id+'/details'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.details') }}</span>
            <i class="fa fa-eye"></i>
            </div>
        </router-link>
        <router-link
                     :to="'pos/bind_serial/'+row.terminal_id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.bind_serial_to_switch') }}</span>
            <i class="fa fa-barcode"></i>
            </div>
        </router-link>
        <router-link
                     :to="'pos/pos_replacement/'+row.followup_code+'/'+row.terminal_id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.pos_replacement') }}</span>
            <i class="fa fa-ellipsis-v"></i>
            </div>
        </router-link>
        <router-link
                     :to="'pos/rollback/'+row.followup_code+'/'+row.terminal_id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.rollback') }}</span>
            <i class="fa fa-power-off"></i>
            </div>
        </router-link>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from "jquery";
import toastr from "toastr";
export default Vue.extend ({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
})
</script>

<style>
.special-tooltip{
    position: relative;
    display: inline-block;
}
.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 60px !important;
}
.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}
.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>